import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, NavLink, useHistory , useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import "../css/main.css";
import Rightcontainer from "../Components/Rightcontainer";
import Downloadbutton from "../Components/Downloadbutton";
import DownloadPopup from "../Components/DownloadPopup";
import io from "../Components/socket";
import Header from "../Components/Header";
import { Token } from "@mui/icons-material";
import SliderCode from "../Components/SliderCode";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false);
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);
  // const [userAllData, setUserAllData] = useState()

  // language
  const translations = {
    hi: { Tournaments: "प्रतियोगिता" },
    en: { Tournaments: "Tournaments" },
  };

  const MyData = localStorage.getItem("meData");
  const meedata = JSON.parse(MyData);
  const { language } = useContext(LanguageContext);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  // console.log(addCaseSetting);

  // const role = async () => {
  //   const access_token = localStorage.getItem('token')
  //   io.emit('getprofile', access_token)
  //   io.on('setProfile', data => {
  //     // setUserAllData(data)
  //   })
  // }

  useEffect(() => {
    // role()
  }, []);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
      backgroundColor: theme === "light" ? "#fff" : "black",
      color: theme === "light" ? "black" : "#fff",
      // padding: '20px',
      // margin: '20px',
    };
  
    const styles3 = {
      backgroundColor: theme === "light" ? "#26355D" : "#27241b",
      color: theme === "light" ? "#fff" : "#fff",
    };

  return (
    <>
      {showDownloadPopup && (
        <DownloadPopup onClose={() => setShowDownloadPopup(false)} />
      )}
      <div
        className="leftContainer mb_space"
        style={{ ...styles, height: "119% !important" }}
      >
        <div className="pt-3 Orher_page_main_section" style={styles}>
          <div className="main-area" style={styles}>
            {JSON.parse(localStorage.getItem("sitSetting"))?.site_message !=
              null &&
              JSON.parse(localStorage.getItem("sitSetting"))?.site_message !=
                "" && (
                <div className="gameCard pt-2" style={styles}>
                  <div className="alrt_msg_div mt-3">
                    <h5 className="">
                      {
                        JSON.parse(localStorage.getItem("sitSetting"))
                          ?.site_message
                      }
                    </h5>
                  </div>
                </div>
              )}
            {/* <SliderCode /> */}

            <section className="games-section" style={styles}>
              <div className="games-section-headline mt-0 pb-2 mb-sm-4 mb-3">
                <div className="games-window">
                  <Link
                    className="gameCard-container"
                    to={
                      addCaseSetting?.isLudokingClassic
                        ? "/Homepage/ludoClassicManual"
                        : "#"
                    }
                  >
                    <div className="gameCard">
                      <span className="d-none blink d-block text-right bg_green game_live_status_position">
                        {addCaseSetting?.isLudokingClassic ? " ◉ LIVE" : " ◉ LIVE"}
                      </span>
                      <picture className="gameCard-image">
                        <img
                          width="100%"
                          src="./mainimage/ludoclassic.png"
                          alt="Ludo Classic"
                        />
                      </picture>
                    </div>
                  </Link>

                  <a
                    href={
                      JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport
                    }
                    target="_blank"
                    rel="noreferrer"
                    className="gameCard-container"
                  >
                    <div className="gameCard">
                      <span className="d-none blink d-block text-right text-danger bg_green game_live_status_position">
                        {" ◉ LIVE"}
                      </span>
                      <picture className="gameCard-image">
                        <img
                          width="100%"
                          src="./mainimage/ludosupport.png"
                          alt="Support"
                        />
                      </picture>
                    </div>
                  </a>
                </div>
              </div>
            </section>
          </div>

        </div>
      </div>
      <div className="support_samll_card_btn_type whatsap_btn">
        {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport ? (
          <>
            <a
              href={
                JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport
              }
              target="_blank"
            >
              {/* <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                alt=""
              /> */}
            </a>
          </>
        ) : (
          ""
        )}
      </div>
      <div
        className="support_samll_card_btn_type whatsap_btn"
        style={{ marginBottom: "65px" }}
      >
        {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile ? (
          <>
            {/* <a
              href={
                `tel:${JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.CompanyMobile}`
              }
              target="_blank"
            >
              <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/phone.png"}
                alt=""
              />
            </a> */}
          </>
        ) : (
          ""
        )}
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
